import { Action } from '@zaibot/fsa';
import { INote } from '../../../types';

export default Action<{items: INote[], batchdelete: boolean }>('NOTES_DELETE_BATCH_START');



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/actions/NOTES_DELETE_BATCH_START.tsx